import { render, staticRenderFns } from "./noticeDetailDialog.vue?vue&type=template&id=2504a4a8&scoped=true"
import script from "./noticeDetailDialog.vue?vue&type=script&lang=js"
export * from "./noticeDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./noticeDetailDialog.vue?vue&type=style&index=0&id=2504a4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504a4a8",
  null
  
)

export default component.exports